export const GESTION_CARTERA_PATH = "/homeAdmin/gestion-cartera";

export const clientProfilePath = (clientUuid) => `${GESTION_CARTERA_PATH}/clientes/${clientUuid}`;

export const creditDetailPath = (clientUuid, creditUuid) =>
  `${clientProfilePath(clientUuid)}/creditos/${creditUuid}`;
